import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//models

//services

//component
import {AuthenticatedComponent} from "../../../../shared/components/AuthenticatedComponent";
import {number} from "ng2-validation/dist/number";
import {MenuService} from "../../../services/menu.service";
import {BsModalRef} from "ngx-bootstrap";
@Component({
	selector: 'app-section-modal',
	templateUrl: './importMenus-modal.component.html',
	styleUrls: ['./importMenus-modal.component.scss']
})

export class ImportMenusModalComponent extends AuthenticatedComponent implements OnInit {

	constructor(public menuService:MenuService,public bsModalRef:BsModalRef){
		super();
	}
  @Input() placeId: number;
  file:any = null;
  clicked: boolean=false;
	ngOnInit() {

	}
  public import()
  {
    this.menuService.ImportMenus(this.file,this.placeId).subscribe(data=>
    {
      this.clicked=false;
      if (!data.hasError)
      {
        this.alertService.showSuccess(this.translate.instant("alerts.IMPORTEDSUCCESSFULLY"));
        this.bsModalRef.hide();
      }
      else{
        let errors = data.errors.map(r => {return r.message});
        this.alertService.showError(errors);
      }
    })
  }
}
